<template>

<b-modal ref="bModal" @ok="$emit('save', user)" @hidden="onHidden" @shown="onShown" :ok-disabled="invalidUser" title="Editar Usuario" size="lg"
         header-bg-variant="primary" header-text-variant="light" ok-title="Guardar">
  <user-form ref="userForm" v-model="user"></user-form>
</b-modal>

</template>

<script>

import UserForm from './UserForm'

export default {
  name: 'EditUserModal',
  components: {UserForm},
  props: {
    initialUser: {required: true}
  },
  data() {
    return {
      user: {...this.initialUser},
      shown: false
    }
  },
  computed: {
    invalidUser() {
      if (!this.shown) {
        return
      }
      return this.$refs.userForm && this.$refs.userForm.invalid
    }
  },
  methods: {
    show() {
      this.$refs.bModal.show()
    },
    onShown() {
      this.shown = true
      this.$refs.userForm.resetValidation()
    },
    onHidden() {
      this.user = {...this.initialUser}
    }
  },
  watch: {
    initialUser: function(value) {
      this.user = {...value}
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/user/EditUserModal.vue